export const getModalData = (type) => (state) => state.modals[type];

export default {
  getModalData,
}
